import { Pipe, PipeTransform } from '@angular/core';
import { DataService } from 'src/app/core/services/data.service';
import { total_enrollOnlyConverterDetail } from '../services/convert.service';
import { pushToObject } from '../services/mapping.service';

@Pipe({
  name: 'totalEnroll'
})
export class TotalEnrollPipe implements PipeTransform {
  total = 0;
  constructor(private ds:DataService){}
  async transform(batchKey): Promise<any> {
    if(!batchKey) return null;
    const data:any = pushToObject(await this.ds.batchLevelFireRef().doc(batchKey).withConverter(total_enrollOnlyConverterDetail).get())
    return data.total_enroll
  }

}
